function languageService () {
  var oLanguageService = {}

  oLanguageService.getLanguage = function () {
    var sLocaleLanguage = null

    if (window.localStorage) {
      sLocaleLanguage = window.localStorage.getItem('preferredLanguage')
    }

    var sLanguage = sLocaleLanguage || window.navigator.userLanguage || window.navigator.language

    if (sLanguage.substring(0, 2).toUpperCase() === 'PT') {
      return 'pt-BR'
    } else if (sLanguage.substring(0, 2).toUpperCase() === 'ES') {
      return 'es-ES'
    } else {
      return 'en-US'
    }
  }

  oLanguageService.setLocaleLanguage = function (sLang) {
    if (window.localStorage) {
      window.localStorage.setItem('preferredLanguage', sLang)
    }
  }

  return oLanguageService
}

export { languageService }
